// src/components/CustomModal.js
import React from "react";
import { Dialog } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";

const Modal = ({ open, onClose, title, children, actions, size }) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth={size}>
      <div
        className="modal-container"
        style={{ display: "flex", flexDirection: "column", height: "100%" }}
      >
        <div
          className="modal-header"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "1rem",
            borderBottom: "1px solid #ccc",
            position: "sticky",
            top: 0,
            backgroundColor: "#fff",
            zIndex: 1111,
          }}
        >
          <h4>{title}</h4>
          <CancelIcon onClick={onClose} style={{ cursor: "pointer" }} />
        </div>

        {/* Scrollable Children Section */}
        <div
          className="modal-body "
          style={{
            flex: 1,
            overflowY: "auto",
            padding: "1rem",
          }}
        >
          {children}
        </div>

        {/* Actions Section */}
        {actions?.length !== 0 && actions !== undefined && actions !== null && (
          <div
            className="modal-actions"
            style={{
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
              padding: "1rem",
              gap: "1rem",
              borderTop: "1px solid #ccc",
            }}
          >
            {actions.map((action, index) => (
              <button
                key={index}
                onClick={action.onClick}
                className={`${action.color}`}
              >
                {action.label}
              </button>
            ))}
          </div>
        )}
      </div>
    </Dialog>
  );
};

export default Modal;
